<template >
    <div class="orders">
        <div class="order-list full-list">
            <div class="order-list__title-box">
                <h2 class="order-list__title">Список заказов</h2>
            </div>
            <div class="order-list__switch">
                <button-component class="order-list__switcher active" button-text="Благоустройство могилы" @click="getOrderType('gravesLandscaping')" />
                <button-component class="order-list__switcher" button-text="Памятник" @click="getOrderType('monument')" />
                <button-component class="order-list__switcher-download" button-text="Скачать" icon-name="download" icon-size="24" @click="downloadOrders()" />
            </div>
            <div class="order-list__search-input tablet">
                <input type="text" placeholder="Поиск">
            </div>
            <div class="order-list-full">
                <div class="order-list-full__wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th @click="openDropdown($event, 'd1')">
                                    <p>№ заказа</p>
                                    <div class="users-list__select-box_dropdown" data-id="d1">
                                        <span>
                                            <input class="input" type="text" placeholder="ВН24/1" v-maska="orderNumberMask" @keydown="getSearchByParams($event)">
                                        </span>
                                        <span @click="sortOrders('number', 'asc')">По алфавиту (А-Я)</span>
                                        <span @click="sortOrders('number', 'desc')">По алфавиту (Я-А)</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd2')">
                                    <p>Статус</p>
                                    <div class="users-list__select-box_dropdown multiple" data-id="d2">
                                        <label>
                                            <input type="checkbox" name="status" value="processing" @change="getOrdersWithStatus()">
                                            <span class="order-list__status processing">Обработка</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" name="status" value="active" @change="getOrdersWithStatus()">
                                            <span class="order-list__status inWork">В работе</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" name="status" value="payment" @change="getOrdersWithStatus()">
                                            <span class="order-list__status paid">Оплачен</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" name="status" value="done" @change="getOrdersWithStatus()">
                                            <span class="order-list__status done">Сделан</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" name="status" value="donePayment" @change="getOrdersWithStatus()">
                                            <span class="order-list__status closed">Закрыт</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" name="status" value="refusal" @change="getOrdersWithStatus()">
                                            <span class="order-list__status refused">Отказ</span>
                                        </label>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd3')">
                                    <p>Дата заключения</p>
                                    <div class="users-list__select-box_dropdown" data-id="d3">
                                        <span>
                                            <input class="input" type="text" placeholder="01.01.2024" v-maska="orderDateMask" @keydown="getSearchByParams($event)">
                                        </span>
                                        <span @click="sortOrders('createdAt', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('createdAt', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd4')">
                                    <p>Дата начала работ</p>
                                    <div class="users-list__select-box_dropdown" data-id="d4">
                                        <span>
                                            <input class="input" type="text" placeholder="01.01.2024" v-maska="orderDateMask" @keydown="getSearchByParams($event)">
                                        </span>
                                        <span @click="sortOrders('datesStartedAt', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('datesStartedAt', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd5')">
                                    <p>ФИО заказчика</p>
                                    <div class="users-list__select-box_dropdown" data-id="d5">
                                        <span>
                                            <input class="input" type="text" placeholder="Иванов Иван Иванович">
                                        </span>
                                        <span @click="sortOrders('informationClient', 'asc')">По алфавиту (А-Я)</span>
                                        <span @click="sortOrders('informationClient', 'desc')">По алфавиту (Я-А)</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd6')">
                                    <p>Телефон</p>
                                    <div class="users-list__select-box_dropdown" data-id="d6">
                                        <span>
                                            <input class="input" type="text" placeholder="+79999999999" v-maska="'+7 ### ###-##-##'">
                                        </span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd7')">
                                    <p>ФИО умершего</p>
                                    <div class="users-list__select-box_dropdown" data-id="d7">
                                        <span>
                                            <input class="input" type="text" placeholder="Иванов Иван Иванович">
                                        </span>
                                        <span @click="sortOrders('informationDeceased', 'asc')">По алфавиту (А-Я)</span>
                                        <span @click="sortOrders('informationDeceased', 'desc')">По алфавиту (Я-А)</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd8')">
                                    <p>Дата смерти</p>
                                    <div class="users-list__select-box_dropdown" data-id="d8">
                                        <span>
                                            <input class="input" type="text" placeholder="01.01.2024" v-maska="orderDateMask">
                                        </span>
                                        <span @click="sortOrders('informationDeathDate', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('informationDeathDate', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd9')">
                                    <p>Кладбище</p>
                                    <div class="users-list__select-box_dropdown" data-id="d9">
                                        <span>
                                            <input class="input" type="text" placeholder="Ермолинское">
                                        </span>
                                        <span @click="sortOrders('informationCemetery', 'asc')">По алфавиту (А-Я)</span>
                                        <span @click="sortOrders('informationCemetery', 'desc')">По алфавиту (Я-А)</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd10')">
                                    <p>Участок/ряд/место</p>
                                    <div class="users-list__select-box_dropdown" data-id="d10">
                                        <span>
                                            <input class="input" type="text" placeholder="1/2/3" v-maska="orderGraveMask">
                                        </span>
                                        <span @click="sortOrders('informationGrave', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('informationGrave', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd11')">
                                    <p>Создатель заказа</p>
                                    <div class="users-list__select-box_dropdown" data-id="d11">
                                        <span>
                                            <input class="input" type="text" placeholder="Иванов Иван Иванович">
                                        </span>
                                        <span @click="sortOrders('userId', 'asc')">По алфавиту (А-Я)</span>
                                        <span @click="sortOrders('userId', 'desc')">По алфавиту (Я-А)</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd12')">
                                    <p>Общая сумма заказа, руб.</p>
                                    <div class="users-list__select-box_dropdown" data-id="d12">
                                        <span>
                                            <input class="input" type="text" placeholder="10000">
                                        </span>
                                        <span @click="sortOrders('priceFinal', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('priceFinal', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd13')">
                                    <p>Производимые работы</p>
                                    <div class="users-list__select-box_dropdown" data-id="d13">
                                        <span>
                                            <input class="input" type="text" placeholder="Установка ограды">
                                        </span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd14')">
                                    <p>Аванс, руб.</p>
                                    <div class="users-list__select-box_dropdown" data-id="d14">
                                        <span>
                                            <input class="input" type="text" placeholder="10000">
                                        </span>
                                        <span @click="sortOrders('paymentsAmount', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('paymentsAmount', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd15')">
                                    <p>Дата внесения денег</p>
                                    <div class="users-list__select-box_dropdown" data-id="d15">
                                        <span>
                                            <input class="input" type="text" placeholder="01.01.2024" v-maska="orderDateMask">
                                        </span>
                                        <span @click="sortOrders('paymentsDate', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('paymentsDate', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd16')">
                                    <p>Сумма долга, руб.</p>
                                    <div class="users-list__select-box_dropdown" data-id="d16">
                                        <span>
                                            <input class="input" type="text" placeholder="10000">
                                        </span>
                                        <span @click="sortOrders('paymentsUndone', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('paymentsUndone', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                                <th @click="openDropdown($event, 'd17')">
                                    <p>Выручка, руб.</p>
                                    <div class="users-list__select-box_dropdown" data-id="d17">
                                        <span>
                                            <input class="input" type="text" placeholder="10000">
                                        </span>
                                        <span @click="sortOrders('total', 'asc')">По возрастанию</span>
                                        <span @click="sortOrders('total', 'desc')">По убыванию</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(order, index) in orders" :key="index">
                                <td>
                                    <div class="order-list__action-box">
                                        <VDropdown>
                                            <button class="order-list__action">
                                                <icon-component class="order-list__icon" name="action" width="22" height="22"/>
                                            </button>
                                            <template #popper>
                                                <div class="order-list__option-box">
                                                    <router-link :to="{ name: 'order', params: { orderId: order._id } }" class="order-list__option">Подробнее</router-link>
                                                    <router-link v-if="role !== UserRole.USER" :to="{ name: 'edit', params: { orderId: order._id } }" class="order-list__option">Редактировать</router-link>
                                                    <button class="order-list__option error" v-if="role !== UserRole.USER && role !== UserRole.MANAGER">Удалить</button>
                                                </div>
                                            </template>
                                        </VDropdown>
                                    </div>
                                </td>
                                <td>{{order.number}}</td>
                                <td>
                                    <span
                                        :class="order.status === 'Обработка' ? 'processing' :
                                        order.status === 'В работе' ? 'inWork' :
                                        order.status === 'Оплачен' ? 'paid' :
                                        order.status === 'Сделан' ? 'done' :
                                        order.status === 'Закрыт' ? 'closed' :
                                        order.status === 'Отказ' ? 'refused' : ''
                                    ">{{ order.status }}</span>
                                </td>
                                <td>{{new Date(order.createdAt).toLocaleDateString()}}</td>
                                <td>{{new Date(order.dates.startAt).toLocaleDateString()}}</td>
                                <td>{{order.information.client}}</td>
                                <td>{{order.information.clientPhone}}</td>
                                <td>{{order.information.deceased}}</td>
                                <td>{{new Date(order.information.deathDate).toLocaleDateString()}}</td>
                                <td>{{order.information.cemetery}}</td>
                                <td>{{order.information.graveDistrict + '/' + order.information.graveRow + '/' + order.information.gravePlace}}</td>
                                <td>{{order.creatorContacts?.fullname}}</td>
                                <td>{{order.price.final.toFixed(2)}}</td>
                                <td>{{order.services.map( (service: any) => service.title).join('\r\n')}}</td>
                                <td>{{order.payments.map( (payment: any) => payment.amount).join('\r\n')}}</td>
                                <td>{{order.payments.map( (payment: any) => new Date(payment.date).toLocaleDateString()).join('\r\n')}}</td>
                                <td>{{(order.price.final - order.payments.reduce((summ: number, payment: any) => summ + payment.amount, 0)).toFixed(2)}}</td>
                                <td>{{order.price.final.toFixed(2)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <pagination></pagination>
    </div>
<!--        <order-list-full-component :sorting= true :date="date" :filtered="filtered"/>-->
</template>
<script setup lang="ts">
import buttonComponent from '../shared/buttonComponent.vue'
import iconComponent from '../shared/iconComponent.vue'
import pagination from '../shared/pagination.vue'
import {onMounted, reactive, ref} from 'vue'
import axios from "../app/lib/api"
import toast from "../app/lib/hooks/errorToast"
import {useLoadingStore} from "../app/store/store"
import {IOrderFilter, IOrderFilterSearchBy, Order, OrderStatus, OrderType} from "../app/lib/types/orders"
import {UserRole} from "../app/lib/types/users"
import {vMaska} from 'maska/vue'
import {MaskInputOptions} from "maska"

const props = defineProps({
    margin: {
        type: Boolean
    },
    link: {
        type: Boolean
    },
    sorting: {
        type: Boolean
    },
    date: {
        type: Array
    },
    filtered: {
        type: Boolean
    },
    quantity: {
        type: Number,
        default: 0
    }
})
const userId = ref("")
const loading = useLoadingStore()
const orders = ref([] as unknown as Order[])
const role = localStorage.getItem("role")
const orderNumberMask = reactive<MaskInputOptions>({
    mask: 'A!/B',
    tokens: {
        A: {
            pattern: /[A-Za-zА-я0-9]/,
            multiple: true
        },
        B: {
            pattern: /\d/,
            multiple: true
        }
    }
})
const orderDateMask = reactive<MaskInputOptions>({
    mask: 'AA.AA.AAAA',
    tokens: {
        A: {
            pattern: /\d/
        }
    }
})
const orderGraveMask = reactive<MaskInputOptions>({
    mask: 'A!/A!/A',
    tokens: {
        A: {
            pattern: /\d/,
            multiple: true
        }
    }
})
const orderType = ref('' as unknown as OrderType)
const searchByParams = ref<IOrderFilterSearchBy[]>()
const searchParams = ref<IOrderFilter>({
    perPage: 20,
    sortBy: 'number',
    sortOrder: 'asc',
    pageOffset: 0,
    useTableMap: true,
    search: {
        // searchBy: searchByParams
    }
})

function openDropdown(event: Event, id: string) {
    if (!['input', 'label', 'span'].includes((event.target as HTMLElement).tagName.toLowerCase())) {
        document.querySelector('.users-list__select-box_dropdown[data-id="' + id + '"]')?.classList.toggle('active')
    }
}

/**
 * Запрос в БД на фильтрацию
 */
async function searchOrders() {
    // axios.order.getOrderList(searchParams)
    //     .then((res: any) => {
    //         orders.value = res.data.result.filter((order: Order) => order.status !== OrderStatus.archive)
    //     })
    //     .catch((err: any) => {
    //         toast('error', "Не удалось найти заказ:" + err)
    //     })
}

/**
 * Переключение типа заказа
 */
function getOrderType(type: string) {
    // console.log(searchParams)
    // loading.loading()
    // axios.order.getOrderList(searchParams)
    //     .then((res: any) => {
    //         orders.value = res.data.result.filter((order: Order) => order.type === type)
    //         console.log(orders.value)
    //         orderType.value = type
    //         loading.load()
    //     })
    //     .catch((err: any) => {
    //         loading.load()
    //         toast('error', "Не удалось найти заказ:" + err)
    //     })
}

/**
 * Поиск по текстовым полям и полям с датой
 */
function getSearchByParams(event: KeyboardEvent) {
    // console.log(searchParams)
    // if(event.key === 'Enter') {
    //     const searchInputs:NodeListOf<HTMLInputElement> = document.querySelectorAll(`.users-list__select-box_dropdown input`)
    //
    //     searchInputs.forEach((searchInput: HTMLInputElement) => {
    //         let searchBy = searchInput.name
    //         if(searchInput.value !== '') {
    //             searchByParams.value.push({
    //                     field: searchBy,
    //                     value: searchInput.value.toString().trim(),
    //                     useRegEx: true
    //                 },
    //                 {
    //                     field: 'type',
    //                     value: orderType
    //                 })
    //         }
    //     })
    //
    //     return searchByParams
    // }
    //
    // return false
}

/**
 * Поиск по типу заказа
 */
function getOrdersWithStatus() {
    // const searchInputs:NodeListOf<HTMLInputElement> = document.querySelectorAll(`.order-list__status ~ input`)
    // let searchByParams:IOrderFilterSearchBy[] = []
    //
    // searchInputs.forEach((searchInput: HTMLInputElement) => {
    //     if(!searchInput.checked) {
    //         let searchBy = searchInput.value
    //         searchByParams.push({
    //                 field: searchBy,
    //                 value: searchInput.value.toString(),
    //                 useRegEx: true
    //             },
    //             {
    //                 field: 'type',
    //                 value: orderType
    //             })
    //     }
    // })
    //
    // return searchByParams
}

/**
 * Сортировка
 */
function sortOrders(field: string, sort: string) {
    // searchParams.value.sortBy = field
    // searchParams.value.sortOrder = sort
    // searchParams.value.search = searchByParams
    // axios.order.getOrderList(searchParams)
    //     .then((res: any) => {
    //         orders.value = res.data.result.filter((order: Order) => order.status !== OrderStatus.archive)
    //     })
    //     .catch((err: any) => {
    //         toast('error', "Не удалось загрузить заказы: " + err)
    //     })
}

/**
 * Пагинация
 */
async function getPage(page: number) {
    // axios.order.getOrderList(searchParams)
    //     .then((res: any) => {
    //         orders.value = res.data.result.filter((order: Order) => order.status !== OrderStatus.archive)
    //     })
    //     .catch((err: any) => {
    //         toast('error', "Не удалось загрузить заказы: " + err)
    //     })
}

/**
 * Скачивание таблицы с заказами.
 */
const downloadOrders = async () => {
    loading.loading()
    let filter = {
        useTableMap: false,
        perPage: 0,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        pageOffset: 0,
        search: {
            searchBy: [{
                field: 'type',
                value: orderType
            }]
        }
    }
    // await axios.order.downloadOrders(filter)
    //     .then((r: any) => {
    //         const url = window.URL.createObjectURL(new Blob([r.data]))
    //         const link = document.createElement('a')
    //         link.href = url
    //         link.setAttribute('download', 'отчёт.xlsx')
    //         document.body.appendChild(link)
    //         link.click()
    //         link.remove()
    //         loading.load()
    //     })
    //     .catch((err: any) => {
    //         toast('error', "Скачивание не удалось: " + err)
    //     })
}

/**
 * Удаление заказа
 */
async function archiveOrder(id: string) {
    try {
        loading.loading()
        await axios.order.updateOrderStatus(id, OrderStatus.archive)
        orders.value = orders.value.filter(order => order._id !== id)
        loading.load()
    } catch (error: any) {
        toast("error", error.response.data.message)
        loading.load()
    }
}

/**
 * Смена статуса заказа
 */
async function setStatus(id: string, status: OrderStatus) {
    try {
        await axios.order.updateOrderStatus(id, status)
        const order = orders.value.find(order => order._id === id )
        if(order){
            order.status = status
        }
    } catch (error: any) {
        loading.load()
        toast("error", error.response.data.message)
    }
}

onMounted(() => {
    axios.users.getUserInfo()
        .then((res: any) => {
            userId.value = res.data.userId
        })

    loading.loading()
    let filter = {
        perPage: 20,
        search: {searchBy: [{field: 'number', value: ''}]}
    }
    axios.order.getOrderList(filter)
        .then((res: any) => {
            orders.value = res.data.result
            loading.load()
        })
        .catch((err: any) => {
            loading.load()
            toast('error', "Не удалось загрузить заказы:" + err)
        })
})
</script>